import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col, Label } from 'react-bootstrap';
import FormInput from 'components/forms/FormInput';

function RemindPeriod(props) {
  const { inModal, entity, disabled } = props;

  const currentDays = entity.getRemindPeriodDays();

  const {
    days_inherited: storedDaysInherited,
    inherited_from_name: storedInheritedFromName,
  } = entity.getEffectiveRemindPeriod();

  const updateEntity = (propertyName, value) => {
    const { entity, changeEntity } = props;
    const daysNumber = Number(value);
    const newDaysValue = Number.isNaN(daysNumber) || daysNumber <= 0 ? null : daysNumber;
    const newEntity = { ...entity.updateValue(propertyName, newDaysValue) };
    changeEntity(newEntity);
  };

  const { messages } = useIntl();

  return (
    <Row>
      <Col xs={12} md={12}>
        <div className="panel panel-transparent">
          <div className="panel-body">
            <h4>{messages.remind_period.title}</h4>
            <div className="form-group-attached">
              {
                <FormInput
                  label={messages.remind_period.days}
                  name="remindPeriodDays"
                  value={currentDays}
                  meta={entity.getRemindPeriodDaysMetaInformation()}
                  validation={entity.getRemindPeriodDaysValidationResult()}
                  onChange={updateEntity}
                  disabled={disabled}
                  type="number"
                  step={1}
                />
              }
              {!currentDays && (
                <div className="form-group form-group-default form-autocomplete">
                  {messages.remind_period.inherited_setting} <Label>{storedDaysInherited}</Label> via &quot;
                  {storedInheritedFromName}
                  &quot;
                </div>
              )}
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
}

export default RemindPeriod;
